// @flow
import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import BoolItem from 'app/components/_ui/BoolItem';
import styles from './ServTypes.scss';


type Props = {
  lkProvided?: boolean,
  lk?: boolean,
  mobileProvided?: boolean,
  mobile?: boolean,
  smsProvided?: boolean,
  sms?: boolean,
  emailProvided?: boolean,
  email?: boolean,
  title: string,
  className?: string,
}

const ServTypes = ({
  lkProvided = false,
  lk = false,
  mobileProvided = false,
  mobile = false,
  smsProvided = false,
  sms = false,
  emailProvided = false,
  email = false,
  title,
  className,
}: Props) => {
  const { t } = useTranslation('subs');

  return (
    <div className={classNames(styles.root, className)}>
      {(lkProvided || smsProvided || mobileProvided || emailProvided)
        && <div className={styles.title}>{`${title}:`}</div>}
      <div className={styles.informs}>
        {lkProvided
          && <BoolItem className={styles.itemFirst} label={t('service_type_lk')} checked={lk} />}
        {smsProvided
          && <BoolItem className={styles.item} label={t('service_type_sms')} checked={sms} />}
      </div>
      <div className={styles.informs}>
        {mobileProvided
          && <BoolItem className={styles.itemFirst} label={t('service_type_mobile')} checked={mobile} />}
        {emailProvided
          && <BoolItem className={styles.item} label={t('service_type_email')} checked={email} />}
      </div>
    </div>
  );
};

export default ServTypes;
